import React from "react";
import PropTypes from 'prop-types';



class QualificationComponent extends React.Component {

    constructor(props) {
        super(props);
        if (this.constructor.name === "QualificationComponent") {
            throw new Error("Abstract classes can't be instantiated.");
        }

        /* eslint-disable no-unused-vars */
        // Cette variable doit être implémentée dans les composants qui étendent celui-ci
        let generableCodes = [];
    }

    render() {
        throw new Error("Method 'render()' must be implemented.");
        /* eslint-disable no-unreachable */
        return (<React.Fragment>Method 'render()' must be implemented.</React.Fragment>);
    }

    componentDidMount() {
        throw new Error("Method 'componentDidMount()' must be implemented.");
    }

    getQualificationData() {
        throw new Error("Method 'getQualificationData()' must be implemented.");
    }

    componentWillUnmount() {
        const { onChange, name } = this.props;

        onChange(name, 0, null, this.generableCodes, "Unmount");
    }


    handleChange = (event) => {
        const { onChange, name } = this.props;

        let newState =
        {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        const { position, toAdd, toDelete } = this.getQualificationData(newState);

        onChange(name, position, toAdd, toDelete, "Life");
    }
}


QualificationComponent.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired
};


export default QualificationComponent;
